import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import ProtectedRoute from "components/ProtectedRoute";
import NotFound from "pages/NotFound";
import UserLogin from './pages/user-login';
import ApplicationForm from './pages/application-form';
import UserDashboard from './pages/user-dashboard';
import UserRegistration from './pages/user-registration';
import InstitutionProfile from './pages/institution-profile';
import InstitutionSearch from './pages/institution-search';
import OnlineLearning from './pages/online-learning';
import CourseDetail from './pages/online-learning/CourseDetail';
import CategoryCourses from './pages/online-learning/CategoryCourses';
import Resources from './pages/resources';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<InstitutionSearch />} />
        <Route path="/user-login" element={<UserLogin />} />
        <Route path="/application-form" element={<ApplicationForm />} />
        <Route path="/online-learning" element={<OnlineLearning />} />
        <Route path="/online-learning/course/:courseId" element={<CourseDetail />} />
        <Route path="/online-learning/courses/:type/:level" element={<CategoryCourses />} />
        <Route path="/resources" element={<Resources />} />
        <Route 
          path="/user-dashboard" 
          element={
            <ProtectedRoute>
              <UserDashboard />
            </ProtectedRoute>
          } 
        />
        <Route path="/user-registration" element={<UserRegistration />} />
        <Route path="/institution-profile" element={<InstitutionProfile />} />
        <Route path="/institution-search" element={<InstitutionSearch />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
